import React from 'react';
import ReactDOM from 'react-dom/client';
import './tailwind.output.css'; // Import the generated Tailwind CSS file
import './index.css'; // Keep your custom CSS
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { initGA } from './utils/analytics';
import { logPerformanceMetrics } from './utils/performance';

// Initialize analytics
initGA();

// Start performance monitoring
logPerformanceMetrics();

// Register service worker with better error handling
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then((registration) => {
        console.log('SW registered: ', registration);
      })
      .catch((registrationError) => {
        console.warn('SW registration failed: ', registrationError);
        // Don't block app if service worker fails
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);